
export function getLocations(state) {
  return state.locations;
}

export function getLocationById(state, locationId) {
  return getLocations(state).get(locationId);
}
